<template>
    <span class="expandable-text">
        <span
            v-if="!escape"
            v-sanitize-html='excerpt'
        ></span>
        <span class="whitespace-pre-line"
            v-if="escape"
        >{{ excerpt }}</span>

        <a href="" @click.prevent="show_all = true" v-if="!show_all && content_too_long">
            {{ trans('calendar.show_more') }}
        </a>
        <slot v-bind:isMobile="isClientMobile" v-bind:showingAll="showing_all"></slot>
        <a href="" @click.prevent="show_all = false" v-if="show_all && content_too_long">
            {{ trans('calendar.show_less') }}
        </a>
    </span>
</template>

<script>
    import IsClientMobile from '@/system/components/mixins/IsClientMobile';
    export default {
        name: 'ExpandableText',

        mixins: [
            IsClientMobile,
        ],

        data() {
            return {
                show_all: false,
            }
        },

        props: {
            cutoff_length: {
                type: Number,
                required: false,
                default: 280
            },

            content: {
                required: true,
            },

            only_mobile: {
                default: false
            },

            escape: {
                default: false
            },
        },

        methods: {
            trans: trans,
        },

        computed: {

            excerpt() {

                let excerpt = this.content;

                if(this.content_too_long && !this.show_all){
                    return [
                        excerpt.substr(0, this.cutoff_length),
                        this.escape ? '...' : '&hellip;'
                    ].join('');
                }


                return excerpt;

            },


            content_too_long(){
                let excerpt = this.content;

                if (!this.only_mobile || this.only_mobile && this.isClientMobile) {
                    if(excerpt.length > this.cutoff_length){
                        return true;
                    }
                }

                return false
            },

            showing_all() {
                return ! this.content_too_long || this.show_all;
            }
        }
    }
</script>
